'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.validateLocaleCode = validateLocaleCode;
exports.validateLocaleData = validateLocaleData;
exports.validateLocales = validateLocales;
exports.validateNgettextMsgid = validateNgettextMsgid;
exports.validateNgettextNumber = validateNgettextNumber;
exports.validateNgettextPluralForms = validateNgettextPluralForms;

var _utils = require('./utils');

function validateLocale(locale, availLocales) {
    if (process.env.NODE_ENV !== 'production') {
        if (!availLocales[locale]) {
            throw new Error('\n                    Locale \'' + locale + '\' is not found in config.\n                    useLocales accepts only existing locales. Use addLocale function before.\n                    Available locales: ' + JSON.stringify(availLocales));
        }
    }
}

function validateLocaleCode(locale) {
    if (process.env.NODE_ENV !== 'production') {
        if (typeof locale !== 'string') {
            throw new Error('Expected locale code to be a string but recieved ' + (typeof locale === 'undefined' ? 'undefined' : _typeof(locale)) + ' insttead');
        }
    }
}

function validateLocaleData(data) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        var addLocaleDoc = 'https://c-3po.js.org/configuration-c-3po-lib.html#addlocale-string-locale-object-data-bool-replacevariablesnames';
        if (!data) {
            throw new Error('\n            Locale data sould not be empty.\n            see - ' + addLocaleDoc + '\n            ');
        }
        if (!data.headers) {
            throw new Error('\n            Locale data sould contain headers "' + JSON.stringify(data) + '".\n            see - ' + addLocaleDoc + '\n            ');
        }
        if (!data.headers['plural-forms'] && !data.headers['Plural-Forms']) {
            throw new Error('\n            Locale data.headers should contain \'Plural-Forms\' attribute "' + JSON.stringify(data) + '".\n            see - ' + addLocaleDoc + '\n            ');
        }
        if (!data.translations) {
            throw new Error('\n            Locale data sould contain translations "' + JSON.stringify(data) + '".\n            see - ' + addLocaleDoc + '\n            ');
        }
        if (!Object.keys(data.translations).length) {
            throw new Error('\n            Locale data.translations should have at least 1 key"' + JSON.stringify(data) + '".\n            see - ' + addLocaleDoc + '\n            ');
        }
    }
}

function validateLocales(locales, availLocales) {
    if (process.env.NODE_ENV !== 'production') {
        if (!Array.isArray(locales)) {
            throw new Error('useLocales accepts only array as the first argument');
        }
        locales.forEach(function (locale) {
            return validateLocale(locale, availLocales);
        });
    }
}

function validateNgettextMsgid(str) {
    if (process.env.NODE_ENV !== 'production') {
        var ngettextDoc = 'https://c-3po.js.org/ngettext.html#usage';
        if (!(str.hasOwnProperty('_strs') && str.hasOwnProperty('_exprs'))) {
            throw new Error('The first argument for ngettext must be tagged with \'msgid\' tag.\n                see - ' + ngettextDoc + ';\n                ');
        }
    }
}

function validateNgettextNumber(n) {
    if (process.env.NODE_ENV !== 'production') {
        var ngettextDoc = 'https://c-3po.js.org/ngettext.html#usage';
        if (!(typeof n === 'number')) {
            throw new Error('The last argument to ngettext - \'' + n + '\' expected to be a number. Got \'' + (typeof n === 'undefined' ? 'undefined' : _typeof(n)) + '\' instead.\n                see - ' + ngettextDoc);
        }
    }
}

function validateNgettextPluralForms(headers, actualFormsCount) {
    if (process.env.NODE_ENV !== 'production') {
        var expectedFormsCount = (0, _utils.getPluralFormsNumber)(headers);
        if (actualFormsCount !== expectedFormsCount) {
            throw new Error(
            // eslint-disable-next-line max-len
            'ngettext expects ' + expectedFormsCount + ' for the current default locale, but received - ' + actualFormsCount + '.\n                Default locale headers: ' + JSON.stringify(headers));
        }
    }
}


//////////////////
// WEBPACK FOOTER
// C:/Work/repo/metabase/metabase_wh/node_modules/c-3po/dist/validation.js
// module id = 834
// module chunks = 7